<template>
  <div class="ad">
    <RectAd/>
    <RectAd eq="2"/>
  </div>
</template>

<script>
import RectAd from './RectAd'

export default {
  name: 'Ad1',
  components: {
    RectAd
  },
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @media all and (max-width: 480px) {
    .second{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ad/Ad1.vue